module.exports = __webpack_public_path__ + "src/assets/img/portrait.76295556.jpg";